module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_bronze_ghost-f3d8ad732f9e8756c55140e9b7ed754a.svg";